<template>
    <div id="navbar" class="container-fluid">
        <nav class="navbar navbar-expand-lg navbar-light fixed-top d-flex flex-row justify-content-lg-center justify-content-between" id="nav">

            <a class="navbar-brand" href="#">
                <img src="../../assets/imgs/general/logo_academie.png" class="img-fluid " alt="">
            </a>

            <button class="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarToggler"
                    aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation"
                    id="toggler">
                <span id="menu">
                    <i class="fas fa-bars"></i>
                </span>
                <span id="close">
                    <i class="fas fa-times"></i>
                </span>
            </button>

            <div class="collapse navbar-collapse collapse navbar-collapse" id="navbarToggler">
                <ul class="navbar-nav  d-flex flex-column flex-lg-row justify-content-center  align-items-center mx-auto">

                    <li class="nav-item active mt-auto mb-2 mb-lg-0">
                        <a class="nav-link" id="leahu_academy_link">Academia Spațială</a>
                    </li>
                    <li class="nav-item my-2 my-lg-0">
                        <a class="nav-link" href="/#tuti_world">Lumea lui Tuti</a>
                    </li>
                    <li class="nav-item my-2 my-lg-0">
                        <a class="nav-link" href="/#games">Antrenamente spațiale</a>
                    </li>
                    <li class="nav-item my-2 my-lg-0">
                        <a class="nav-link" href="/#yummy">Yummy Galaxy</a>
                    </li>
                    <li class="nav-item my-2 my-lg-0">
                        <a class="nav-link" href="#contact">Contact</a>
                    </li>

                    <li class="mb-auto mt-2 ml-lg-2 ml-lg-auto d-block d-lg-none">
                        <button data-toggle="modal" data-target="#login-modal" id="toggleLoginModal"
                                class="py-1 px-3 px-lg-4 loginButton"
                                @click="showModal()">
                            Acces Cadeți
                        </button>

                        <div id="myProfile" class="myProfileButton">
                            <router-link
                                    to="/profile">
                                Profilul Meu
                            </router-link>
                        </div>
                    </li>


                </ul>
            </div>

            <div class="navbar-buttons">
                <div class="d-none d-lg-block">
                    <button data-toggle="modal" data-target="#login-modal" id="toggleLoginModal"
                            class="py-1 px-3 px-lg-4 loginButton"
                            @click="showModal()">
                        Acces Cadeți
                    </button>

                    <div id="myProfile" class="myProfileButton">
                        <router-link
                                to="/profile">
                            Profilul Meu
                        </router-link>
                    </div>
                </div>

            </div>

        </nav>

        <login-modal v-show="loginModalClicked"
                     @codeScanned="onCodeScanned"></login-modal>
    </div>
</template>

<script>
    import LoginModal from './LoginModal'
    import * as uuid from 'uuid';
    import Swal from 'sweetalert2';

    const axios = require('axios');

    const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000
    });

    export default {
        name: "Navbar",
        components: {
            LoginModal
        },
        data() {
            return {
                loginModalClicked: false,
            }
        },
        mounted() {
            const $ = window.$;
            let self = this;

            window.onscroll = function () {
                scrollFunction()
            };

            function scrollFunction() {
                if (document.body.scrollTop > $('nav').height() / 2 || document.documentElement.scrollTop > $('nav').height() / 2) {
                    $('nav').addClass('bg-white');
                    $('.navbar-buttons').addClass('bg-white');
                    $('nav').addClass('shadow');
                    $('nav img').css('width', '70%');
                    $('nav img').css('transition', 'width 0.5s');
                    $('nav #menu i').css('color', '#0b4366');
                } else {
                    $('nav').removeClass('bg-white');
                    $('.navbar-buttons').removeClass('bg-white');
                    $('nav').removeClass('shadow');
                    $('nav #menu i').css('color', '#fff');
                    if ($(window).width() >= 500) {
                        $('nav img').css('width', '100%');
                        $('nav img').css('transition', 'width 0.5s');
                    }
                }
            }

            $('#toggler').click(function () {
                setTimeout(function () {
                    if (document.getElementById('navbarToggler').classList.contains('show')) {
                        console.log('show');
                        $('#app').addClass('fixed-height')
                    } else {
                        $('#app').removeClass('fixed-height')
                    }
                }, 100)
            });

            $('.nav-link').click(function () {
                $(".navbar-collapse").collapse('hide');
            });

            $('.loginButton').click(function () {
                $(".navbar-collapse").collapse('hide');
            });

            $('.myProfileButton').click(function () {
                $(".navbar-collapse").collapse('hide');
            });

            $('#leahu_academy_link').on('click', function () {

                if (self.$router.currentRoute.name === 'landing') {
                    const y = $('#leahu_academy').offset().top;
                    window.scroll({
                        top: y - 100,
                        behavior: 'smooth'
                    });
                } else {
                    self.$router.push('/');
                    setTimeout(function () {
                        const y = $('#leahu_academy').offset().top;
                        window.scroll({
                            top: y - 100,
                            behavior: 'smooth'
                        });
                    }, 500);
                }


            });

            $(document).ready(function () {
                setTimeout(function () {
                    if ($(window).width() < 500) {
                        let btnWidth = document.getElementById('toggler').getBoundingClientRect();
                        $('#navbar .navbar-brand img').css('margin-left', parseInt(btnWidth.width) + 'px');
                    }
                }, 100);
            });

            if (this.$cookie.get('access-token') && this.$cookie.get('access-token') !== '') {
                $('#toggleLoginModal').addClass('d-none');
                $('.loginButton').removeClass('d-block').addClass('d-none');
                $('#myProfile').addClass('d-block');
                $('.myProfileButton').removeClass('d-none').addClass('d-block');
            } else {
                $('#myProfile').addClass('d-none');
                $('.myProfileButton').removeClass('d-block').addClass('d-none');
                $('#toggleLoginModal').addClass('d-block');
                $('.loginButton').removeClass('d-none').addClass('d-block');
            }

            $('#login-modal').on("hidden.bs.modal", function () {
                this.loginModalClicked = false;
                document.getElementById('toggler').setAttribute('aria-expanded', false);
            });

            $('.modal').on('hidden.bs.modal', function () {
                this.loginModalClicked = false;
                document.getElementById('toggler').setAttribute('aria-expanded', false);
            });

            $('#app').click(function () {
                this.loginModalClicked = false;
                document.getElementById('toggler').setAttribute('aria-expanded', false);
            });

        },
        methods: {
            onCodeScanned(code) {
                const $ = window.$;
                let baseUrl = this.$cookie.get('base-url');
                let loginUrl = baseUrl + 'api/auth/login';
                let self = this;
                const kidTerminal = uuid.v4();
                let headers = {};
                if (this.$cookie.get('terminal-uid')) {
                    headers = {'terminal-uid': this.$cookie.get('terminal-uid')};
                } else {
                    headers = {'terminal-uid': kidTerminal};
                }

                axios.post(loginUrl, {code: code}, {headers})
                    .then(function (response) {

                        $('#toggleLoginModal').click();
                        self.loginModalClicked = false;

                        self.$cookie.set('access-token', response.data.result.token_type + ' ' + response.data.result.access_token, 1);
                        self.$cookie.set('terminal-uid', kidTerminal, 1);
                        self.$cookie.set('user_id', response.data.result.user.id, 1);

                        self.$store.commit('setUser', response.data.result.user);
                        self.$router.push('profile');

                        if (self.$cookie.get('access-token') && self.$cookie.get('access-token') !== '') {
                            $('#toggleLoginModal').addClass('d-none');
                            $('#myProfile').addClass('d-block')
                            $('.loginButton').removeClass('d-block').addClass('d-none');
                            $('.myProfileButton').removeClass('d-block').addClass('d-block')
                        } else {
                            $('#toggleLoginModal').addClass('d-none');
                            $('#myProfile').addClass('d-none');
                            $('.loginButton').removeClass('d-block').addClass('d-none');
                            $('.myProfileButton').removeClass('d-block').addClass('d-none')
                        }

                        Toast.fire({
                            type: 'error',
                            title: 'Cardul a fost scanat cu succes!',
                            animation: true,
                            customClass: {
                                popup: 'animated tada'
                            }
                        });
                    })
                    .catch(function (error) {
                        console.log(error);

                        Toast.fire({
                            type: 'error',
                            title: 'Cardul nu este valid!',
                            animation: true,
                            customClass: {
                                popup: 'animated tada'
                            }
                        });
                    });
            },
            showModal() {
                const $ = window.$;
                this.loginModalClicked = !this.loginModalClicked;
                $('#navbarToggler').removeClass('show');
            },
        }
    }
</script>

<style lang="scss">
    @import '../../styles/navbar.scss';
</style>
